import { ViewTransition } from "react";
import { redirect } from "next/navigation";
import { getSession } from "@/lib/auth/session";
import { AdminShell } from "./_components/admin-shell";
import { BottomDock } from "./_components/bottom-dock";

export const dynamic = "force-dynamic";

export default async function AdminLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const session = await getSession();
  if (!session) redirect("/login");

  return (
    <div className="mf-admin-root relative min-h-screen bg-background">
      <main className="relative min-h-screen pb-32">
        <ViewTransition enter="mf-page-in" exit="mf-page-out">
          <AdminShell>{children}</AdminShell>
        </ViewTransition>
      </main>
      <BottomDock />
    </div>
  );
}
